import React, { useState, useRef } from 'react';
import { FiSearch, FiX, FiPlus } from 'react-icons/fi';



/**
 * SearchBar Component
 * Search input for filtering conversations with new message button
 *
 * @param {Object} props
 * @param {string} props.value - Current search value
 * @param {function} props.onChange - Handler for search input changes
 * @param {string} props.placeholder - Placeholder text
 * @param {function} props.onNewMessage - Handler for new message button click
 */
const SearchBar = ({
  value = '',
  onChange,
  placeholder = 'Search or start new chat',
  onNewMessage
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  const handleClear = () => {
    onChange('');
    inputRef.current?.focus();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleClear();
    }
  };

  return (
    <div className="talk-search-container">
      <div className="talk-search-bar-wrapper">
        <div className={`talk-search-wrapper ${isFocused ? 'talk-search-focused' : ''}`}>
          <FiSearch
            className="talk-search-icon"
            size={16}
            aria-hidden="true"
          />

          <input
            ref={inputRef}
            type="text"
            className="talk-search-input"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            onKeyDown={handleKeyDown}
            aria-label="Search conversations"
          />

          {value && (
            <button
              className="talk-search-clear"
              onClick={handleClear}
              aria-label="Clear search"
              type="button"
            >
              <FiX size={16} />
            </button>
          )}
        </div>

        <button
          className="talk-new-message-btn"
          onClick={onNewMessage}
          aria-label="Start new conversation"
          title="New message"
          type="button"
        >
          <FiPlus size={20} />
        </button>
      </div>
    </div>
  );
};

export default SearchBar;
